import { Route, BrowserRouter, Routes } from 'react-router-dom';

import { Home } from '../pages/Home';
import { Game } from '../pages/Game';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Home />} path="/" exact />
        <Route element={<Game />} path="/game" />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
